interface SEOData {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schemaData?: Record<string, unknown>[];
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export function useSEO(data: SEOData) {
  return {
    title: data.title.includes('国产视频在线观看') ? data.title : `${data.title} - 国产视频在线观看`,
    description: data.description,
    keywords: data.keywords,
    canonicalUrl: data.canonicalUrl,
    ogType: data.ogType || 'website',
    ogImage: data.ogImage,
    schemaData: data.schemaData || [],
    articlePublishedTime: data.articlePublishedTime,
    articleModifiedTime: data.articleModifiedTime,
  };
}

export function SEOHeadTags({ data }: { data: ReturnType<typeof useSEO> }) {
  return (
    <>
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <meta name="keywords" content={data.keywords} />
      <link rel="canonical" href={data.canonicalUrl} />
      <meta name="robots" content="index, follow" />
      <meta name="geo.region" content="CN" />
      <meta name="geo.placename" content="中国" />

      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:type" content={data.ogType} />
      <meta property="og:url" content={data.canonicalUrl} />
      <meta property="og:site_name" content="国产视频在线观看" />
      <meta property="og:locale" content="zh_CN" />
      {data.ogImage && <meta property="og:image" content={data.ogImage} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={data.title} />
      <meta name="twitter:description" content={data.description} />
      {data.ogImage && <meta name="twitter:image" content={data.ogImage} />}

      {data.articlePublishedTime && <meta property="article:published_time" content={data.articlePublishedTime} />}
      {data.articleModifiedTime && <meta property="article:modified_time" content={data.articleModifiedTime} />}

      {data.schemaData.map((schema, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </>
  );
}